import { useMemo } from 'react'

import { Button } from '@wartek-id/button-v1'
import { Text } from '@wartek-id/text'

import usePeriodContext from 'app/KinerjaShared/hooks/usePeriodContext'
import { addMonthsToDate, formatDate } from 'utils/datetime'

import ImgTermConditionTNCList from 'assets/icons/img-term-condition-tnc-list.svg'

interface TabRangkumanReadyProps {
  onClickBackToHome?: () => any
}

const TabRangkumanReady = ({
  onClickBackToHome = () => {},
}: TabRangkumanReadyProps) => {
  const { period: periodData } = usePeriodContext()

  const steps = useMemo(() => {
    const start = addMonthsToDate(periodData?.startDate, 1)
    const month = formatDate(start, 'MMMM')
    return [
      {
        title: 'Perencanaan akan otomatis disetujui',
        description:
          'Perencanaan Kinerja Anda akan otomatis disetujui dan disampaikan ke atasan.',
      },
      {
        title: 'Menunggu tahap berikutnya',
        description: `Anda dapat lanjut ke tahap berikutnya: Pelaksanaan mulai dari 1 ${month}. Mohon ditunggu, ya.`,
      },
    ]
  }, [periodData])

  return (
    <div className="p-9 flex justify-center">
      <div className="w-[500px] p-9 flex flex-col">
        <ImgTermConditionTNCList width={84} height={84} />

        <Text variant="heading-lg" className="mt-4">
          Perencanaan Kinerja selesai! Tahap selanjutnya adalah:
        </Text>

        <div className="flex flex-col gap-4 mt-4">
          {steps.map(({ title, description }, i) => (
            <div key={title} className="flex gap-2">
              <div className="flex justify-center items-center bg-gray-80 rounded-full p-3 self-start">
                <Text variant="body-sm" color="inverse" className="absolute">
                  {i + 1}
                </Text>
              </div>
              <div className="flex flex-col gap-1">
                <Text variant="action">{title}</Text>
                <Text variant="body-sm" color="subdued">
                  {description}
                </Text>
              </div>
            </div>
          ))}
        </div>

        <Button
          size="lg"
          color="black"
          className="mt-4"
          fullWidth
          onClick={onClickBackToHome}
        >
          Kembali ke Beranda
        </Button>
      </div>
    </div>
  )
}

export default TabRangkumanReady
